<template>
  <b-avatar
      variant="primary"
      :src="avatar_url"
      :text="avatar_letters"
      :size="avatar_size"
  />
</template>

<script>
export default {
  props: {
    user: Object,
    size: String,
  },
  data() {
    let userData = this.user ?? this.$store.state.auth.user;

    return {
      avatar_url: userData.avatar_url,
      avatar_letters: userData.first_name.substring(0, 1) + userData.last_name.substring(0, 1),
      avatar_size: this.size ?? "32px"
    };
  }
}
</script>